module.exports = require("./select2.js");
require("./select2.css");
require("./select2.png");
require("./select2x2.png");
require("./select2-spinner.gif");


//////////////////
// WEBPACK FOOTER
// select2 (bower component)
// module id = 360
// module chunks = 1